import type { ReactNode } from 'react';
import { Provider } from 'react-redux';
import { ConfirmProvider } from '../providers/ConfirmProvider';
import { store } from '../store/store';
import { MockAuthEffects } from './MockAuthEffects';
import { LazyMsalProvider } from './LazyMsalProvider';

type AppProvidersProps = {
  children: ReactNode;
};

export const AppProviders = ({ children }: AppProvidersProps) => (
  <Provider store={store}>
    <MockAuthEffects />
    <LazyMsalProvider>
      <ConfirmProvider>{children}</ConfirmProvider>
    </LazyMsalProvider>
  </Provider>
);
